import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { GeneralSetting } from 'src/model/GeneralSetting';
import { generalSettingsActions } from 'src/store/slices/generalSettingsSlice';
import { RootState } from 'src/store/store';

export const useGeneralSettings = () => {
    const dispatch = useDispatch();
    const ac = bindActionCreators(generalSettingsActions, dispatch);
    const { generalSettings } = useSelector((state: RootState) => state.generalSettings);

    useEffect(() => {
        ac.getSettings();
    }, [ac]);

    const updateGeneralSettings = useCallback((settings: Partial<GeneralSetting>) => {
        const updatedSettings = { ...generalSettings, ...settings };
        ac.setGeneralSettings(updatedSettings);
    }, [ac, generalSettings]);

    const handleLogout = useCallback(() => {
        ac.logout();
    }, [ac]);

    const incrementUncoveredWordCount = useCallback(() => {

        const currentCount = generalSettings.UncoverWordCount;
        const newCount = currentCount + 1;
        updateGeneralSettings({ UncoverWordCount: newCount });
    }, [updateGeneralSettings, generalSettings]);

    const incrementRangePopUpCount = useCallback(() => {
        const currentCount = generalSettings.RangePopUpCount || 0;
        const newCount = currentCount + 1;
        updateGeneralSettings({ RangePopUpCount: newCount });
    }, [updateGeneralSettings, generalSettings]);

    return {
        generalSettings,
        updateGeneralSettings,
        handleLogout,
        incrementUncoveredWordCount,
        incrementRangePopUpCount
    };
}; 